/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * @param  {ctx} ctx
 * @return {void}
 */
export default (response, ctx) => {
    const page = document.getElementById('page');

    // Mark current children
    for (let i = 0; i < page.children.length; i++) {
        const child = page.children[i];

        child.classList.add('current-page-content');
    }

    page.insertAdjacentHTML('beforeend', response.data);

    TweenMax.set('.slider-holder', { autoAlpha: 0 });

    // Pass the component definition to the resolve callback
    EventBus.$once('page-transition-mounted', () => {
        const onComplete = () => {
            TweenMax.set('.slider-holder', { clearProps: 'zIndex', position: 'absolute' });
            TweenMax.set('.slider-holder .transition-curtain', { clearProps: 'all' });
            TweenMax.set('.slide .subline .movement-container', { clearProps: 'all' });
            TweenMax.set('.slide .scroll .movement-container', { clearProps: 'all' });
            TweenMax.set('.slide h1 .movement-container', { clearProps: 'all' });
            TweenMax.set('.slide-image-holder', { clearProps: 'all' });
            TweenMax.set(['.slider-control .circle'], { clearProps: 'all' });
            TweenMax.set(['.slider-control.next .arrow'], { clearProps: 'all' });
            TweenMax.set(['.slider-control.previous .arrow'], { clearProps: 'all' });

            App.router.pageTransitionComplete();
        };

        // Setup
        TweenMax.set('.slider-holder', { zIndex: 15, position: 'fixed' });
        TweenMax.set(['.slider-control .circle'], { scale: 0 });
        TweenMax.set(['.slider-control.next .arrow'], { autoAlpha: 0, y: '-25%' });
        TweenMax.set(['.slider-control.previous .arrow'], { autoAlpha: 0, y: '25%' });

        TweenMax.set('.slide .subline .movement-container', { y: '100%' });
        TweenMax.set('.slide .scroll .movement-container', { y: '-100%' });

        TweenMax.set('.slide h1 .movement-container', { y: '100%' });
        TweenMax.set('.slide-image-holder', { autoAlpha: 0 });
        TweenMax.set('.slider-holder', { autoAlpha: 1 });

        this.enterTl = new TimelineMax({
            paused: true, onComplete,
        });

        this.enterTl.timeScale(1.1);

        this.enterTl
            .to('.slider-holder .transition-curtain', 1, { scaleY: 1, ease: CustomEase.create('custom', 'M0,0 C0.25,0.1 0.25,1 1,1') })
            .to('.slide .subline .movement-container', 0.8, { y: '0%' }, 0.6)
            .to('.slide .scroll .movement-container', 0.8, { y: '0%' }, 0.6)
            .set('.slide .scroll', { className: '-=animate-out' }, 0.2)
            .to('.slide h1 .movement-container', 0.8, { y: '0%' }, 0.6)
            .to('.slide-image-holder', 0.8, { autoAlpha: 1 }, 1.1)
            .to(['.slider-control .circle'], 0.8, { scale: 1, transformOrigin: 'center center' }, 0.8)
            .to(['.slider-control.next .arrow'], 0.8, { autoAlpha: 1, y: '0%' }, 0.8)
            .to(['.slider-control.previous .arrow'], 0.8, { autoAlpha: 1, y: '0%' }, 0.8);

        window.requestAnimationFrame(() => {
            this.enterTl.play();
        });

        TweenMax.delayedCall(0.8, () => {
            App.darkHeader = false;
        });
    });

    App.router.buildPage('#page');
};



// WEBPACK FOOTER //
// ./resources/assets/js/navigation/transitions/default-to-homepage.js